document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-drawer]');
  if (toggle && drawer) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      drawer.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }

  const productJsonEl = document.querySelector('[data-product-json]');
  const variantSelect = document.querySelector('[data-variant-select]');
  if (productJsonEl && variantSelect) {
    const variants = JSON.parse(productJsonEl.textContent);
    document.querySelectorAll('.option-group input').forEach(input => {
      input.addEventListener('change', () => {
        const selected = Array.from(document.querySelectorAll('.option-group')).map(group => group.querySelector('input:checked')?.value);
        const match = variants.find(v => v.options.every((opt, i) => opt === selected[i]));
        if (match) {
          variantSelect.value = match.id;
          const url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        }
      });
    });
  }
});

document.addEventListener('click', function (event) {
  const swatch = event.target.closest('.product-card__swatch');

  if (!swatch) return;

  const card = swatch.closest('.product-card');
  if (!card) return;

 const image = card.querySelector('.product-card__image-wrap img');
const color = swatch.getAttribute('title')?.trim().toLowerCase();

if (image && !card.dataset.originalImage) {
  card.dataset.originalImage = image.currentSrc || image.src;
}

const productName = card.querySelector(
  '.product-card__title, .product-card__info a, a[href*="/products/"]'
)?.textContent?.trim().toLowerCase() || '';

const productLink = card.querySelector('[data-product-image-link]');
const productHandle = productLink?.getAttribute('href')?.toLowerCase() || '';

const isMilano = productName.includes('milano') ||
                 productName.includes('milan') ||
                 productHandle.includes('milano') ||
                 productHandle.includes('milan');

const lifestyleColor = isMilano ? 'natural' : 'black';

const imageUrl = color === lifestyleColor
  ? card.dataset.originalImage
  : swatch.dataset.variantImage;
  const variantUrl = swatch.dataset.variantUrl;
  
  const imageLink = card.querySelector('[data-product-image-link]');
  const hoverImage = card.querySelector(
  '.product-card__image--hover, .product-card__image-hover'
);
const hoverUrl = swatch.dataset.variantHover;

  if (imageUrl && image) {
  image.removeAttribute('srcset');
  image.removeAttribute('sizes');
  image.src = imageUrl;

  image.style.opacity = '1';
  image.style.visibility = 'visible';
}

if (hoverImage) {
  const isLifestyleColor = color === lifestyleColor;

  if (isLifestyleColor && hoverUrl) {
    hoverImage.src = hoverUrl;
    hoverImage.removeAttribute('srcset');
    hoverImage.removeAttribute('sizes');
    hoverImage.style.removeProperty('display');
  } else {
    hoverImage.style.setProperty('display', 'none', 'important');
  }
}

 

  if (variantUrl && imageLink) {
    imageLink.href = variantUrl;
  }

  card.querySelectorAll('.product-card__swatch').forEach(function (item) {
    item.classList.remove('is-active');
    item.setAttribute('aria-pressed', 'false');
  });

  swatch.classList.add('is-active');
  swatch.setAttribute('aria-pressed', 'true');
});

// Save connection test